export const userAddress = {
  addressConfirm: {
    title: 'TU SOLICITUD DE CAMBIO DE DOMICILIO PERSONAL HA SIDO ENVIADA',
    txt: 'En breve te confirmaremos la actualización de los datos.',
    btn: 'Volver a mis datos'
  },
  addressForm: {
    title: 'Solicitud de cambio de domicilio personal',
    btn: 'Enviar solicitud',
    fields: {
      tipoDeVia: {
        label: 'Tipo de vía'
      },
      calle: {
        label: 'Calle'
      },
      numero: {
        label: 'Número'
      },
      bloque: {
        label: 'Bloque'
      },
      escalera: {
        label: 'Escalera'
      },
      piso: {
        label: 'Piso'
      },
      puerta: {
        label: 'Puerta'
      },
      cpostal: {
        label: 'CP'
      },
      poblacion: {
        label: 'Población'
      },
      provincia: {
        label: 'Provincia'
      },
      pais: {
        label: 'País'
      },
      telefono: {
        label: 'Teléfono'
      },
      email: {
        label: 'Correo electrónico'
      }
    }
  },
  breadcrumb: {
    first: 'Mis datos',
    second: 'Solicitar cambio de domicilio'
  },
  editButton: 'SOLICITAR CAMBIO DE DOMICILIO',
  pending: 'Tienes una solicitud de cambio de domicilio pendiente de validar'
};
